module.exports = __webpack_public_path__ + "img/531c6a6.jpg";